import React from 'react'
import { DonutChartLegend as Legend, } from '../../../components';
import { PieChart, Pie, Cell } from 'recharts';
import { useViewport, viewportBreakpoint } from '../../../utils';

const COLORS2 = ['#52BAE2', '#FF5448']

const GenderChart = ({data, total}) => {
  const { width } = useViewport()
  const breakpoint = viewportBreakpoint.tablet
  const isMobile = width < breakpoint
  const size = isMobile ? 110 : 92

  return (
    <div className="flex justify-between md:justify-start lg:justify-between lg:block">
      <div className="mb-5 md:mr-4 lg:mr-0">
        <Legend data={data} total={total} colors={['#52BAE2', '#FF5448']} />
      </div>
      <PieChart width={size} height={size}>
        <Pie
          data={data}
          cx={size/2.19}
          cy={size/2.19}
          innerRadius={0}
          outerRadius={size/2}
          fill="#8884d8"
          paddingAngle={2}
          dataKey="value"
        >
          {
            data.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS2[index % COLORS2.length]} />)
          }
        </Pie>
      </PieChart>
    </div>
  )
}

export { GenderChart }